import {axios} from '../helpers/http_client';

class UsernameInfo {

    constructor() {
        this.userExists = false;
        this.userHasPassword = false;
        this.userType = null;
        this.username = null;
        this.usernameVerified = false;
        this.isSuspended = false;
        this.isAdmin = false;
    }

    /**
     *
     * @param {object} entity
     * @return {UsernameInfo}
     */
    static make(entity) {
        const usernameInfo = new UsernameInfo();

        usernameInfo.userExists = entity.user_exists ?? false;
        usernameInfo.userHasPassword = entity.user_has_password ?? false;
        usernameInfo.userType = entity.user_type ?? null;
        usernameInfo.username = entity.username ?? null;
        usernameInfo.usernameVerified = entity.username_verified ?? false;
        usernameInfo.isSuspended = (entity.user_status && entity.user_status === 'suspended');
        usernameInfo.isAdmin = entity.is_admin ?? false;

        return usernameInfo;
    }
}

/**
 *
 * @param {string} username
 *
 * @return {Promise<UsernameInfo>}
 */
function getUsernameInfo(username) {
    const path = `v1/users/usernameInfo/${username}`;

    return new Promise((resolve, reject) => {
        axios.get(path).catch(error => {
            reject(error);
        }).then(response => {
            resolve(UsernameInfo.make(response.data));
        });
    });
}

export default UsernameInfo;
export {
    getUsernameInfo
};